var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        opacity: .95;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-apps"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 800,
    height: 800
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.74,407.47c.46-6.05,4.17-70.13-47.66-112.93-56.16-46.37-124.65-24.11-128.47-22.79-37.38-66.23-115.78-98.45-188.56-77.7-73.63,20.98-123.45,91.02-119.14,167.84-57.92,16.85-96.85,70.92-94.28,129.5,2.4,54.63,40.41,102.56,94.28,118.11h174.46v-190.23h-60.96l120.58-104.89,120.58,104.89h-60.96v190.23h181.83c50.14-8.64,86.86-52.04,87.03-101.53.16-46.73-32.3-88.58-78.74-100.49Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedsWhite);
export default __webpack_public_path__ + "static/media/reds_white.435b40ff03add05e60b3199bec6ee8c8.svg";
export { ForwardRef as ReactComponent };